const EmptyBox = () => {
    return (
        <div className="card position-sticky top-10" style={{ backgroundColor: '#e3e3e3' }}>
            <div className="card-body py-12" style={{ backgroundColor: '#e3e3e3' }}>
                <p className="text-sm mt-3 text-center">Select a dispute to view details.</p>
            </div>
        </div>
    );
};

export default EmptyBox;